import api from 'api'

export const getUsersByNameRepository = async (searchValue) => {
  let url = `${process.env.REACT_APP_HEADERS_DOMAIN}/api/users?paginate=0`
  if (searchValue) {
    url += `&search=${searchValue}`
  }
  return api.get(url)
}

export const getUsersRepository = async (page, searchValue, clientsId) => {
  let url = `${process.env.REACT_APP_HEADERS_DOMAIN}/api/users?page=${page}`
  if (searchValue) {
    url += `&search=${searchValue}`
  }
  if (clientsId) {
    url += `&clients_id=${clientsId}`
  }
  return api.get(url)
}

export const removeUsersRepository = async (user_id) => api.delete(`${process.env.REACT_APP_HEADERS_DOMAIN}/api/users/${user_id}`)
